/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';
var filterTags = require('../data/accommodation_filter_tags');

function hasSomeDataFilled(list) {
    return Odigeo._.some(Odigeo._.isArray(list) ? list : [list], Odigeo._.negate(Odigeo._.isEmpty));
}

function hasSelectedFilter(data, selected) {
    return Odigeo._.isObject(data) && !Odigeo._.isEmpty(data[selected]);
}

function hasSelectedFilterItems(data) {
    return hasSelectedFilter(data, 'selectedItems');
}

function hasSelectedFilterHotelName(data) {
    return hasSelectedFilter(data, 'hotelName');
}

function hasSelectedFilterOurSelection(data) {
    return Odigeo._.get(data, 'isOurSelection', false);
}

function hasSelectedFilterPrice(data) {
    return Odigeo._.isObject(data) && (Odigeo._.lt(data.selectedMaxPrice, Number.MAX_VALUE) || Odigeo._.gt(data.selectedMinPrice, 0));
}

function hasSelectedFilterDistance(data, maxDistance) {
    var hasSelectedFilter = Odigeo._.isObject(data) && Odigeo._.isNumber(data.selectedDistance);

    return hasSelectedFilter && Odigeo._.lt(data.selectedDistance, maxDistance);
}

function hasSelectedFilterNeighbourhood(data) {
    return hasSelectedFilter(data, 'selectedItems');
}

function hasSelectedFilterBoardType(data) {
    return hasSelectedFilter(data, 'selectedItems');
}

function validateGlobalFilter(isFiltered, activatedTags, tagName) {
    if (isFiltered) {
        activatedTags[tagName] = filterTags[tagName];
    }
}

function validateOptionFilter(data, activatedTags) {
    if (hasSelectedFilterItems.call(this, data)) {
        Odigeo._.each(data.selectedItems, function(option) {
            validateGlobalFilter(true, activatedTags, option);
        }, this);
    }
}

function doValidates(newResultSet, maxDistance) {
    var activatedTags = {};
    validateGlobalFilter(hasSelectedFilterItems.call(this, newResultSet.categoryFilterModel), activatedTags, 'GUEST_RATING');
    validateGlobalFilter(hasSelectedFilterItems.call(this, newResultSet.reviewFilterModel), activatedTags, 'GUEST_REVIEWS');
    validateGlobalFilter(hasSelectedFilterHotelName.call(this, newResultSet.hotelNameFilterModel), activatedTags, 'HOTEL_NAME');
    validateGlobalFilter(hasSelectedFilterOurSelection.call(this, newResultSet.filterByOurSelectionModel), activatedTags, 'OUR_SELECTION');
    validateGlobalFilter(hasSelectedFilterPrice.call(this, newResultSet.accommodationPriceFilterModel), activatedTags, 'PRICE_RANGE');
    validateGlobalFilter(hasSelectedFilterDistance.call(this, newResultSet.distanceFilterModel, maxDistance), activatedTags, 'DISTANCE_CENTER');
    validateGlobalFilter(hasSelectedFilterNeighbourhood.call(this, newResultSet.filterByNeighbourhoodModel), activatedTags, 'NEIGHBOURHOOD');
    return activatedTags;
}

function validateOptions(newResultSet, activatedTags) {
    validateOptionFilter(newResultSet.facilityGroupFilterModel, activatedTags);
    validateOptionFilter(newResultSet.accommodationTypeFilterModel, activatedTags);
    validateOptionFilter(newResultSet.cancellationFreeAndPayLaterFilterModel, activatedTags);
}

function getValidateActivateTags(response) {
    var newResultSet = response.accommodationSearchResultsMetadata;
    var maxDistance = response.accommodationFiltersMetadata.distanceMetadata.maxDistance;
    var activatedTags = doValidates(newResultSet, maxDistance);
    validateGlobalFilter(hasSelectedFilterBoardType.call(this, newResultSet.filterByBoardTypeModel), activatedTags, 'BOARD_TYPE');
    validateOptions(newResultSet, activatedTags);
    return activatedTags;
}

module.exports = {
    hasSomeDataFilled: hasSomeDataFilled,
    hasSelectedFilterItems: hasSelectedFilterItems,
    hasSelectedFilterPrice: hasSelectedFilterPrice,
    hasSelectedFilterDistance: hasSelectedFilterDistance,
    getValidateActivateTags: getValidateActivateTags,
};
